window.createCanvasCustomiserV2 = function(target,base_source){
    var ProductCustomiser = {
        parts: {},
        create_font: function(name,url,size,color){
            if(this.fonts[name] == null){
                this.fonts[name] = window.createTTFFont(name,url,size,color)
            }
            return this.fonts[name]
        },
        get_font: function(name){
            return this.fonts[name]
        },
        create_element: function(element,...args){
            this.elements.push(this.parts[element].create(...args))
            return this.elements[this.elements.length-1]
        },
        render: function(){
            this.canvas.context.save()
            this.canvas.context.fillStyle = "#FFFFFF";
            this.canvas.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.context.restore()
            this.elements.sort((a,b)=>{
                if(a.z < b.z){
                    return -1
                }
                else if(a.z > b.z){
                    return 1
                }
                return 0
            })
            this.canvas.context.drawImage(this.base_image, 0, 0)
            for(var i = 0;i < this.elements.length;i++){
                this.canvas.context.save()
                this.elements[i].render(this.canvas)
                this.canvas.context.restore()
            }
            this.canvas.get.dispatchEvent(new CustomEvent('canvas_rendered',{
                detail: this,
                bubbles: true
            }))
        },
        reset(){
            for(var i = 0;i < this.elements.length;i++){
                this.elements[i].reset()
            }
        },
        init(target,base_img_src){
            this.canvas.get = document.querySelector(target)
            if(this.canvas.get !== null){
                this.base_image = new Image();
                this.base_image.setAttribute('crossOrigin','anonymous');
                this.base_image.src = base_img_src
                this.base_image.addEventListener('load', function(){
                    this.canvas.width = this.base_image.naturalWidth
                    this.canvas.height = this.base_image.naturalHeight
                    this.canvas.get.setAttribute('width',this.canvas.width)
                    this.canvas.get.setAttribute('height',this.canvas.height)
                    this.canvas.context = this.canvas.get.getContext("2d")
                    this.canvas.context.imageSmoothingEnabled = true
                    this.canvas.context.imageSmoothingQuality = 'high';
                    document.addEventListener('canvas_customiser_render',function(e){
                        this.render()
                    }.bind(this))
                    this.ready = true
                    this.canvas.get.dispatchEvent(new CustomEvent('canvas_ready',{
                      bubbles: true
                    }))
                    this.render()
                }.bind(this))
            }
        },
        add_element: function(name,extension){
            this.parts[name] = Object.create(extension)
        },
        create: function(target,base_img_src){
            var newMe = Object.create(this)
            newMe.canvas = {
                get: null,
                context: null,
                width: null,
                height: null,
            }
            newMe.ready = false
            newMe.fonts = {}
            newMe.elements = []
            newMe.base_image = null
            newMe.init(target,base_img_src)
            return newMe
        },
        toImage(){
            return this.canvas.get.toDataURL()
        },
        toPDF(){
            if(jspdf != null){
                var src_image = new Image();
                src_image.src = this.toImage()
                var doc = new jspdf.jsPDF();
                var width = doc.internal.pageSize.getWidth()-20
                var height = (this.canvas.height/this.canvas.width)*width
                doc.addImage(src_image,10,10,width,height);
                var output = doc.output()
                return 'data:application/pdf;base64,' + btoa(output);
            }
            else{
                console.log('Cant Export to PDF, jsPDF is absent')
            }
        }
    }

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
    }

    function checkColor(colors,offset,r,g,b){
        var matches = false
        for(var i = 0;i < colors.length;i++){
            if (
                colors[i].r >= r-offset && colors[i].r <= r+offset &&
                colors[i].g >= g-offset && colors[i].g <= g+offset &&
                colors[i].b >= b-offset && colors[i].b <= b+offset
            ){
                matches = colors[i]
                break
            }
        }
        return matches
    }

    ProductCustomiser.add_element('mask',{
        create: function(src_image,colors,offset = 10,invert = false,z = 0){
            var newMe = Object.create(this)
            newMe.offset = offset
            newMe.z = z
            newMe.invert = invert
            newMe.calculated_ready = false
            newMe.init(colors,src_image)
            newMe.called_unready = false
            return newMe
        },
        init: function(colors,src_image){
            this.colors = []
            for(var i = 0;i < colors.length;i++){
                this.colors[i] = hexToRgb(colors[i])
            }
            this.calculateMask(src_image)
        },
        calculateMask: function(image_src){
            var sub_func = function(src_image){
                this.calculated.width = src_image.naturalWidth
                this.calculated.height = src_image.naturalHeight
                var ctx = this.calculated.getContext("2d")
                ctx.drawImage(src_image, 0, 0)
                var imgData = ctx.getImageData(0, 0, this.calculated.width, this.calculated.height)
                var colorOffset = this.offset
                for (var i = 0; i < imgData.data.length; i += 4) {
                    if(checkColor(this.colors,colorOffset,imgData.data[i],imgData.data[i+1],imgData.data[i+2])){
                        if(this.invert == true){
                            imgData.data[i+3] = 0
                        }
                    }
                    else{
                        if(this.invert == false){
                            imgData.data[i+3] = 0
                        }
                    }
                }
                ctx.putImageData(imgData, 0, 0);
                this.calculated_ready = true
                if(this.called_unready == true){
                  document.dispatchEvent(new CustomEvent('canvas_customiser_render'))
                }
            }.bind(this)

            this.calculated = document.createElement('canvas');
            var src_image = new Image();
            src_image.setAttribute('crossOrigin','anonymous');
            src_image.src = image_src
            if(src_image.complete == true){
                sub_func(src_image)
            }
            else{
                src_image.addEventListener('load', function(){
                    sub_func(this)
                })
            }
        },
        render: function(canvas){
            if(this.calculated_ready == true){
                canvas.context.drawImage(this.calculated, 0, 0, canvas.width, canvas.height)
                this.called_unready = false
            }
            else{
                this.called_unready = true
            }
        },
        reset(){}
    })

    ProductCustomiser.add_element('mask_sides',{
        create: function(src_image,colors,offset = 10,invert = false,z = 0){
            var newMe = Object.create(this)
            newMe.offset = offset
            newMe.z = z
            newMe.invert = invert
            newMe.calculated_ready = false
            newMe.init(colors,src_image)
            newMe.called_unready = false
            return newMe
        },
        init: function(colors,src_image){
            this.colors = []
            for(var i = 0;i < colors.length;i++){
                this.colors[i] = hexToRgb(colors[i])
            }
            this.calculateMask(src_image)
        },
        calculateMask: function(image_src){
            var sub_func = function(src_image){
                this.calculated.width = src_image.naturalWidth
                this.calculated.height = src_image.naturalHeight
                var ctx = this.calculated.getContext("2d")
                ctx.drawImage(src_image, 0, 0)
                var imgData = ctx.getImageData(0, 0, this.calculated.width, this.calculated.height)
                var colorOffset = this.offset
                var rowWidth = src_image.naturalWidth*4
                for (var row = 0; row < imgData.data.length;row += rowWidth){
                    var mask_start = row+rowWidth-4
                    var mask_end = row
                    for (var i = row; i < row+rowWidth; i += 4) {
                        if (checkColor(this.colors,colorOffset,imgData.data[i],imgData.data[i+1],imgData.data[i+2]) == false){
                            mask_start = i
                            break;
                        }
                    }
                    for (var i = row+rowWidth-4; i >= row; i -= 4) {
                        if (checkColor(this.colors,colorOffset,imgData.data[i],imgData.data[i+1],imgData.data[i+2]) == false){
                            mask_end = i
                            break;
                        }
                    }
                    for (var i = row; i < row+rowWidth; i += 4) {
                        if(this.invert == false){
                            if (mask_start <= i && mask_end >= i){
                                imgData.data[i+3] = 0
                            }
                        }
                        else{
                            if (mask_start > i && mask_end < i){
                                imgData.data[i+3] = 0
                            }
                        }
                    }
                }
                ctx.putImageData(imgData, 0, 0);
                this.calculated_ready = true
                if(this.called_unready == true){
                  document.dispatchEvent(new CustomEvent('canvas_customiser_render'))
                }
            }.bind(this)

            this.calculated = document.createElement('canvas');
            var src_image = new Image();
            src_image.setAttribute('crossOrigin','anonymous');
            src_image.src = image_src
            if(src_image.complete == true){
                sub_func(src_image)
            }
            else{
                src_image.addEventListener('load', function(){
                    sub_func(this)
                })
            }
        },
        render: function(canvas){
            if(this.calculated_ready == true){
                canvas.context.drawImage(this.calculated, 0, 0, canvas.width, canvas.height)
                this.called_unready = false
            }
            else{
                this.called_unready = true
            }
        },
        reset(){}
    })

    ProductCustomiser.add_element('texture',{
        create: function(mask_image,z = 0){
            var newMe = Object.create(this)
            newMe.z = z
            newMe.calculated_ready = false
            newMe.texture_image_ready = false
            newMe.texture_image = null
            newMe.init(mask_image)
            newMe.called_unready = false
            return newMe
        },
        init: function(mask_image){
            this.mask_image_ready = false
            this.mask_image = new Image();
            this.mask_image.setAttribute('crossOrigin','anonymous');
            this.mask_image.src = mask_image
            if(this.mask_image.complete == true){
                this.mask_image_ready = true
                if(this.mask_image_ready == true && this.texture_image_ready == true){
                    this.calculateMask()
                }
            }
            else{
                this.mask_image.addEventListener('load', function(){
                    this.mask_image_ready = true
                    if(this.mask_image_ready == true && this.texture_image_ready == true){
                        this.calculateMask()
                    }
                }.bind(this))
            }
        },
        setTexture: function(src){
            this.texture_image_ready = false
            this.calculated_ready = false
            this.texture_image = new Image()
            this.texture_image.setAttribute('crossOrigin','anonymous');
            this.texture_image.src = src
            if(this.texture_image.complete == true){
                this.texture_image_ready = true
                if(this.mask_image_ready == true && this.texture_image_ready == true){
                    this.calculateMask()
                }
            }
            else{
                this.texture_image.addEventListener('load', function(){
                    this.texture_image_ready = true
                    if(this.mask_image_ready == true && this.texture_image_ready == true){
                        this.calculateMask()
                    }
                }.bind(this))
            }
        },
        calculateMask: function(){
            this.calculated = document.createElement('canvas');
            var ctx = this.calculated.getContext("2d")

            this.calculated.width = this.mask_image.naturalWidth
            this.calculated.height = this.mask_image.naturalHeight
            ctx.drawImage(this.mask_image, 0, 0, this.calculated.width, this.calculated.height)
            var maskImgData = ctx.getImageData(0, 0, this.calculated.width, this.calculated.height)

            ctx.drawImage(this.texture_image, 0, 0, this.calculated.width, this.calculated.height)
            var textureImgData = ctx.getImageData(0, 0, this.calculated.width, this.calculated.height)

            for(var i = 0;i < textureImgData.data.length;i+=4){
                if(i < maskImgData.data.length){
                    textureImgData.data[i+3] = maskImgData.data[i+3]
                }
                else{
                    textureImgData.data[i+3] = 0
                }
            }
            ctx.putImageData(textureImgData, 0, 0);
            this.calculated_ready = true
            if(this.called_unready == true){
              document.dispatchEvent(new CustomEvent('canvas_customiser_render'))
            }
        },
        render: function(canvas){
            if(this.calculated_ready == true){
                canvas.context.drawImage(this.calculated, 0, 0, canvas.width, canvas.height)
                this.called_unready = false
            }
            else{
                this.called_unready = true
            }
        },
        reset(){}
    })
    
    ProductCustomiser.add_element('image',{
        create: function(image_src,x,y,width,height,z = 0){
            var newMe = Object.create(this)
            newMe.x = x
            newMe.y = y
            newMe.width = width
            newMe.height = height
            newMe.z = z
            newMe.setSrc(image_src)
            return newMe
        },
        init: function(){
            if(this.image.complete == true){
                this.ready = true
                if(this.called_unready == true){
                  document.dispatchEvent(new CustomEvent('canvas_customiser_render'))
                }
            }
            else{
              this.image.addEventListener('load', function(){
                  this.ready = true
                  if(this.called_unready == true){
                    document.dispatchEvent(new CustomEvent('canvas_customiser_render'))
                  }
              }.bind(this))
            }
        },
        setSrc: function(image_src){
            this.src = image_src
            if(this.src != '' && this.src != null){
                this.called_unready = false
                this.ready = false
                this.image = new Image();
                this.image.setAttribute('crossOrigin','anonymous');
                this.image.src = this.src
                this.init()
            }
        },
        render: function(canvas){
            if(this.src != '' && this.src != null){
                if(this.ready == true){
                    canvas.context.drawImage(this.image, 0, 0, this.width, this.height)
                    this.called_unready = false
                }
                else{
                    this.called_unready = true
                }
            }
        },
        reset(){
            this.src = ''
        }
    })

    ProductCustomiser.add_element('text_box_simple',{
        create: function(font,x,y,z = 0,max_char = 0){
            var newMe = Object.create(this)
            newMe.font = font
            newMe.x = x
            newMe.y = y
            newMe.z = z
            newMe.rotation = 0
            newMe.max_char = max_char
            newMe.banned = []
            newMe.text = ''
            return newMe
        },
        setBanned: function(list){
            if(this.banned.length == 0){
                this.banned = list.split(',').map((v)=>v.trim()).map((v)=>v.toUpperCase())
            }
        },
        setText: function(text){
            var text_filter = text.split(' ').map((v)=>v.trim()).map((v)=>v.toUpperCase())
            if(this.banned.some(banned=>text_filter.includes(banned))){
                this.text = ''
            }
            else{
                this.text = text
            }
        },
        setRotation: function(degrees){
            this.rotation = (degrees % 360)
        },
        setFont: function(font){
            this.font = font
        },
        render: function(canvas){
            if(this.text != null && this.text != ''){
                canvas.context.translate(this.x, this.y);
                canvas.context.rotate(this.rotation * Math.PI / 180);
                var textToUse = this.text
                if(textToUse.length > this.max_char){
                    textToUse = textToUse.slice(0,this.max_char)
                }
                this.text = this.font.drawText(textToUse,canvas)
                this.text = textToUse
            }
        },
        reset(){
            this.text = ''
        }
    })
    
    ProductCustomiser.add_element('text_box',{
        create: function(font,x,y,z = 0,max_width = 0,curved = false,radius = 0,max_arc = 0,use_curve_interrupt = false){
            var newMe = Object.create(this)
            newMe.font = font
            newMe.x = x
            newMe.y = y
            newMe.z = z
            newMe.rotation = 0
            newMe.max_width = max_width
            newMe.curved = curved
            newMe.radius = radius
            newMe.max_arc = max_arc
            newMe.use_curve_interrupt = use_curve_interrupt
            newMe.banned = []
            newMe.text = ''
            return newMe
        },
        setBanned: function(list){
            if(this.banned.length == 0){
                this.banned = list.split(',').map((v)=>v.trim()).map((v)=>v.toUpperCase())
            }
        },
        setText: function(text){
            var text_filter = text.split(' ').map((v)=>v.trim()).map((v)=>v.toUpperCase())
            if(this.banned.some(banned=>text_filter.includes(banned))){
                this.text = ''
            }
            else{
                this.text = text
            }
        },
        setRotation: function(degrees){
            this.rotation = (degrees % 360)
        },
        setFont: function(font){
            this.font = font
        },
        render: function(canvas){
            if(this.text != null && this.text != ''){
                canvas.context.translate(this.x, this.y);
                canvas.context.rotate(this.rotation * Math.PI / 180);
                var useAutoCurved = false
                var textToUse = this.text
                var test = this.font.autoCurveTest(textToUse,this.max_width,this.curved,this.use_curve_interrupt,canvas)
                textToUse = test[0]
                if(this.use_curve_interrupt == true){
                    useAutoCurved = test[1]
                }
                if(this.curved == false || (this.use_curve_interrupt == true && useAutoCurved == 0)){
                    this.text = this.font.drawText(textToUse,canvas)
                }
                else{
                    this.text = this.font.drawTextCurved(
                        textToUse,
                        this.radius,
                        this.max_arc,
                        canvas
                    )
                }
            }
        },
        reset(){
            this.text = ''
        }
    })

    return ProductCustomiser.create(target,base_source)
}